import * as tslib_1 from "tslib";
// Core components
import { SimpleChange } from "@angular/core";
import { MatDialog } from "@angular/material";
// Third party components
import { FieldArrayType } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { take } from "rxjs/operators";
// Custom components
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
/**
 * Script start
 */
var RepeatStructureoptionsTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RepeatStructureoptionsTypeComponent, _super);
    function RepeatStructureoptionsTypeComponent(translateService, dialog) {
        var _this = _super.call(this) || this;
        _this.translateService = translateService;
        _this.dialog = dialog;
        _this.subscriptions = [];
        _this.onDestroy$ = new Subject();
        _this.availableOptions = [];
        _this.delBntenable = true;
        return _this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    RepeatStructureoptionsTypeComponent.prototype.ngOnInit = function () {
        this.to.add = this.add.bind(this);
        this.to.remove = this.remove.bind(this);
    };
    /**
     * Listen on input values changes
     *
     * @since 1.0.0
     */
    RepeatStructureoptionsTypeComponent.prototype.ngOnChanges = function (changes) {
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    RepeatStructureoptionsTypeComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle click on "Remove section" button and trigger a confirmation dialog to ask user if
     * he confirm to remove row. If yes, than remove row.
     *
     * @since 1.0.0
     */
    RepeatStructureoptionsTypeComponent.prototype.onRemove = function (indexToRemove) {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("dialogs.confirm.removeMessage"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.close")
            },
            width: "500px",
            disableClose: true
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        this.subscriptions.push(dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res2) {
            if (res2) {
                // Actually delete field
                _this.remove(indexToRemove);
            }
        }));
    };
    return RepeatStructureoptionsTypeComponent;
}(FieldArrayType));
export { RepeatStructureoptionsTypeComponent };
